import { Component,ViewChild, AfterViewInit ,OnInit,ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatPaginator, MatSort} from '@angular/material';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { DataUserService } from '../Services/data-user.service';
import { DataApiService } from '../Services/data-api.service';
import { DialogCopyPedidoComponent } from '../components/dialogs/dialog-copy-pedido/dialog-copy-pedido.component';
import { VerDatosUsuarioPorServicioComponent } from '../components/dialogs/ver-datos-usuario-por-servicio/ver-datos-usuario-por-servicio.component';
import { VerConstanciaComponent } from '../components/dialogs/ver-constancia/ver-constancia.component';
import { AlertComponent } from '../components/dialogs/alert/alert.component';
import * as moment from 'moment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements AfterViewInit ,OnInit { 
  

  public formularioCambiarEstado={
    id_pedido :null,
    estado:null
  }
  public formularioCambiarFechaPorAtender = {
    id_pedido: null,
    fecha_por_atender: null,
    time_por_atender : null
  }

  public formularioCambiarFechaRecojo = {
    id_pedido: null,
    fecha_recogido: null,
    time_recogido : null
  }

  public formularioCambiarFechaEntrega = {
    id_pedido: null,
    fecha_entregado: null,
    time_entregado : null
  }

  public formularioCambiarFechaDevolucion = {
    id_pedido: null,
    fecha_devuelto: null,
    time_devuelto : null
  }

  public formularioCambiarFechaAnulado = {
    id_pedido: null,
    fecha_anulado: null,
    time_anulado : null
  }

  public formularioCambiarPrecio ={
    id_pedido:null,
    precio:null
  }

  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  itemPerPage = 20;
  idUser = this.DataUser.dataUser(this.dataApi.tokenUser(localStorage.getItem("token")));
  typeUser = localStorage.getItem("type");
  typeUserEmpresa = localStorage.getItem("tipoUsuarioEmpresa"); 
  convenio = localStorage.getItem("convenio");
 
  displayedColumns: string[] = [
    'id_pedido',
    /*'email', */
    /*'motorizado', */
    'infoPedido',  
    'precio',
    /*'precio_convenio',*/
    'modoPago',
    'copiarPedido',
    /*'estado',*/    
    /*'fecha_por_atender',
    'fecha_recogido',
    'fecha_entregado',
    'fecha_devolucion',
    'fecha_anulado',*/
    /*'liquidado',  */   
  ];
  
  public error = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private http: HttpClient,    
    private DataUser:DataUserService,
    private dataApi:DataApiService,
    private dialog: MatDialog,
    
  ){} 
  
  private url =this.dataApi.url;

  errorPriceNoNumeric:string= null;

   
  verDatosUsuario(row){
    this.dialog.open(VerDatosUsuarioPorServicioComponent,{
      width:"40%",
      data:{row},
      disableClose: false,
      autoFocus:true
    });   
  } 
  nuevosPedidos:boolean = false;

  consultarCambios(){  
    const horaAtender = moment().format("YYYY-MM-DD HH:mm:ss");
    if(this.typeUser=="admin"){
      setInterval(()=>{
        this.dataApi.consultarCambios(horaAtender).subscribe((data)=>{
          this.nuevosPedidos = data["nuevoPedido"]; 
          if(Notification.permission === "granted"){
            if(data["nuevoPedido"]){
                new Notification('Información Johnson Miller',{
                  icon: 'https://www.app.johnsonmiller.co/assets/logo.png',
                  body: 'Se ha agregado un nuevo pedido, por favor actualize su navegador'
                })
            } 
          } 
        })
      }, 10000)
    }  
  }


  refresh(){
    location.reload()
  }


  ngOnInit(){
    if(this.typeUser=="admin"){
        Notification.requestPermission()
        .then(res=>{
          console.log("Respuesta",res)
        })
    }
    this.consultarCambios();
  
  }
  ngAfterViewInit() {     
    

    this.exampleDatabase = new ExampleHttpDatabase(this.http,this.dataApi);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.typeUserEmpresa,this.typeUser,this.idUser,"all",this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);      
   } 

  infoPedidosToJson(infoPedido){
    try {
      return JSON.parse(infoPedido);
    } catch (e) {
      return [];
    }
     
  }

  

  formCambiarEstado(id_pedido){
    this.formularioCambiarEstado.id_pedido=id_pedido; 
    (document.querySelector(".formEstado_"+id_pedido) as HTMLElement).style.display ="flex";      
  }   

  cerrarForm(id_pedido){
    (document.querySelector(".formEstado_"+id_pedido) as HTMLElement).style.display ="none";
  }

  cambiarPedidoEstado(){
    this.http.post(`${this.url}/actualizarEstadoPedido`,this.formularioCambiarEstado).subscribe((data)=>{
      if(data == 1){
        const estado = this.formularioCambiarEstado.estado;
        const id_pedido = this.formularioCambiarEstado.id_pedido;
        const estado_modificar = document.querySelector(".estadoColumn__result__estados__"+id_pedido);

        const styles="width:16px;height:16px;float:left;margin-right:10px;border-radius:8px";  
               
          
        if( estado== 0){   
          estado_modificar.innerHTML=`<p><i style="${styles};background-color:#666;"></i> Por atender</p>`;            
        }else if( estado== 1){  
          estado_modificar.innerHTML=`<p><i style="${styles};background-color:#e2801d;"></i> Recogido</p>`;
        }else if( estado == 2 ){ 
          estado_modificar.innerHTML=`<p><i style="${styles};background-color:#28db00;"></i> Entregado</p>`;
        }else if( estado == 3 ){
          estado_modificar.innerHTML=`<p><i style="${styles};background-color:#7a0101;"></i> Anulado</p>`;  
        }else if( estado == 4 ){
          estado_modificar.innerHTML=`<p><i style="${styles};background-color:#FF0000;"></i> Devuelto</p>`;            
        } 
        this.formularioCambiarEstado.estado=""; 
        this.cerrarForm(id_pedido);
        }
      })
  } 

    /*fecha por atender */
    formCambiarFechaPorAtender(id_pedido){
      this.formularioCambiarFechaPorAtender.id_pedido = id_pedido;
      (document.querySelector(".formFechaPorAtender_"+id_pedido) as HTMLElement).style.display ="flex";
      this.cerrarForm(id_pedido);
      this.cerrarFormCambiarFechaRecogido(id_pedido);
      this.cerrarFormCambiarFechaEntregado(id_pedido);
      this.cerrarFormCambiarFechaDevuelto(id_pedido);
      this.cerrarFormCambiarFechaAnulado(id_pedido);

    }   
    cerrarFormCambiarFechaPorAtender(id_pedido){
      (document.querySelector(".formFechaPorAtender_"+id_pedido) as HTMLElement).style.display ="none";
      //vaciar campos
      this.formularioCambiarFechaPorAtender.fecha_por_atender="";
      this.formularioCambiarFechaPorAtender.time_por_atender="";
    }
    cambiarFechaPorAtender(){       
      this.http.post(`${this.url}/actualizarFechaPorAtender`,this.formularioCambiarFechaPorAtender).subscribe(()=>{
        
        const id_pedido = this.formularioCambiarFechaPorAtender.id_pedido;
        const fechaPorAtender = this.formularioCambiarFechaPorAtender.fecha_por_atender;
        const timePorAtender = this.formularioCambiarFechaPorAtender.time_por_atender;
        const contenido_datetime =document.querySelector(".fecha_por_atender_"+id_pedido);
        contenido_datetime.innerHTML=fechaPorAtender +" " +timePorAtender;
        
        this.cerrarFormCambiarFechaPorAtender(id_pedido);
      })
    }

    /*fecha de recojo */


    formCambiarFechaRecogido(id_pedido){      
      this.formularioCambiarFechaRecojo.id_pedido = id_pedido;
      (document.querySelector(".formFechaRecogido_"+id_pedido) as HTMLElement).style.display ="flex";
      this.cerrarForm(id_pedido);
      this.cerrarFormCambiarFechaPorAtender(id_pedido);
      this.cerrarFormCambiarFechaEntregado(id_pedido);
      this.cerrarFormCambiarFechaDevuelto(id_pedido);
      this.cerrarFormCambiarFechaAnulado(id_pedido);
    }   
    cerrarFormCambiarFechaRecogido(id_pedido){
      (document.querySelector(".formFechaRecogido_"+id_pedido) as HTMLElement).style.display ="none";
      this.formularioCambiarFechaRecojo.fecha_recogido="";
      this.formularioCambiarFechaRecojo.time_recogido="";
    }
    cambiarFechaRecogido(){       
      this.http.post(`${this.url}/actualizarFechaRecogido`,this.formularioCambiarFechaRecojo).subscribe(()=>{        
        const id_pedido = this.formularioCambiarFechaRecojo.id_pedido;
        const fechaRecogido = this.formularioCambiarFechaRecojo.fecha_recogido;
        const timeRecogido = this.formularioCambiarFechaRecojo.time_recogido;
        const contenido_datetime =document.querySelector(".fecha_recogido_"+id_pedido);
        contenido_datetime.innerHTML=fechaRecogido +" " +timeRecogido;
        this.cerrarFormCambiarFechaRecogido(id_pedido);        
      })
    }

  /* fecha de entrega */
  formCambiarFechaEntregado(id_pedido){      
    this.formularioCambiarFechaEntrega.id_pedido = id_pedido;
    (document.querySelector(".formFechaEntregado_"+id_pedido) as HTMLElement).style.display ="flex";
    this.cerrarForm(id_pedido);
    this.cerrarFormCambiarFechaPorAtender(id_pedido);
    this.cerrarFormCambiarFechaRecogido(id_pedido);
    this.cerrarFormCambiarFechaDevuelto(id_pedido);
    this.cerrarFormCambiarFechaAnulado(id_pedido);
  }   
  cerrarFormCambiarFechaEntregado(id_pedido){
    (document.querySelector(".formFechaEntregado_"+id_pedido) as HTMLElement).style.display ="none";
    this.formularioCambiarFechaEntrega.fecha_entregado="";
    this.formularioCambiarFechaEntrega.time_entregado="";
  }
  cambiarFechaEntregado(){       
    this.http.post(`${this.url}/actualizarFechaEntregado`,this.formularioCambiarFechaEntrega).subscribe(()=>{        
      const id_pedido = this.formularioCambiarFechaEntrega.id_pedido;
      const fechaEntregado = this.formularioCambiarFechaEntrega.fecha_entregado;
      const timeEntregado = this.formularioCambiarFechaEntrega.time_entregado;
      const contenido_datetime =document.querySelector(".fecha_entregado_"+id_pedido);
      contenido_datetime.innerHTML=fechaEntregado +" " +timeEntregado;
      this.cerrarFormCambiarFechaEntregado(id_pedido);        
    })
  }

  /*fecha devolucion */
  formCambiarFechaDevuelto(id_pedido){      
    this.formularioCambiarFechaDevolucion.id_pedido = id_pedido;
    (document.querySelector(".formFechaDevuelto_"+id_pedido) as HTMLElement).style.display ="flex";
    this.cerrarForm(id_pedido);
    this.cerrarFormCambiarFechaPorAtender(id_pedido);
    this.cerrarFormCambiarFechaRecogido(id_pedido);
    this.cerrarFormCambiarFechaEntregado(id_pedido);
    this.cerrarFormCambiarFechaAnulado(id_pedido);
  }   
  cerrarFormCambiarFechaDevuelto(id_pedido){
    (document.querySelector(".formFechaDevuelto_"+id_pedido) as HTMLElement).style.display ="none";
    this.formularioCambiarFechaDevolucion.fecha_devuelto="";
    this.formularioCambiarFechaDevolucion.time_devuelto="";
  }
  cambiarFechaDevuelto(){       
    this.http.post(`${this.url}/actualizarFechaDevuelto`,this.formularioCambiarFechaDevolucion).subscribe(()=>{        
      const id_pedido = this.formularioCambiarFechaDevolucion.id_pedido;
      const fechaDevuelto = this.formularioCambiarFechaDevolucion.fecha_devuelto;
      const timeDevuelto = this.formularioCambiarFechaDevolucion.time_devuelto;
      const contenido_datetime =document.querySelector(".fecha_devuelto_"+id_pedido);
      contenido_datetime.innerHTML=fechaDevuelto +" " +timeDevuelto;
      this.cerrarFormCambiarFechaDevuelto(id_pedido);        
    })
  }

  /*fecha anulado*/

  formCambiarFechaAnulado(id_pedido){      
    this.formularioCambiarFechaAnulado.id_pedido = id_pedido;
    (document.querySelector(".formFechaAnulado_"+id_pedido) as HTMLElement).style.display ="flex";
    this.cerrarForm(id_pedido);
    this.cerrarFormCambiarFechaPorAtender(id_pedido);
    this.cerrarFormCambiarFechaRecogido(id_pedido);
    this.cerrarFormCambiarFechaEntregado(id_pedido);
    this.cerrarFormCambiarFechaDevuelto(id_pedido);
   
  }   
  cerrarFormCambiarFechaAnulado(id_pedido){
    (document.querySelector(".formFechaAnulado_"+id_pedido) as HTMLElement).style.display ="none";
    this.formularioCambiarFechaAnulado.fecha_anulado="";
    this.formularioCambiarFechaAnulado.time_anulado="";
  }
  cambiarFechaAnulado(){       
    this.http.post(`${this.url}/actualizarFechaAnulado`,this.formularioCambiarFechaAnulado).subscribe(()=>{        
      const id_pedido = this.formularioCambiarFechaAnulado.id_pedido;
      const fechaAnulado = this.formularioCambiarFechaAnulado.fecha_anulado;
      const timeAnulado = this.formularioCambiarFechaAnulado.time_anulado;
      const contenido_datetime =document.querySelector(".fecha_anulado_"+id_pedido);
      contenido_datetime.innerHTML=fechaAnulado +" " +timeAnulado;
      this.cerrarFormCambiarFechaAnulado(id_pedido);        
    })
  }
  /*copiar pedido */
  copyPedido(row){    
    this.dialog.open(DialogCopyPedidoComponent,{
      width:"40%",
      data:row,
      disableClose: false,
      autoFocus:true
    });   
   
    const pedidoWatsapp = `
      N° Pedido : ${row.id_pedido}
      Lugar de recojo: ${row.lugarRecojo}
      Fecha de recojo : ${row.fechaRecojo}
      Hora de recojo : ${row.horaRecojo}
      Observaciones recojo : ${row.observaciones_recojo}
      Lugar de entrega: ${row.lugarEntrega}
      Fecha de entrega : ${row.fechaEntrega}
      Hora de entrega : ${row.horaEntrega}
      Observaciones entrega : ${row.observaciones_entrega}
      Retorno : ${(row.retorno==1)?"SI" : "NO"}
      COD : ${(row.cod==1)?"SI" : "NO"}
      Descripción :${row.descripcion}  
    `;
    const aux = document.createElement("textarea");
    aux.value= pedidoWatsapp;
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
  }

  /* precioConvenio */
  formCambiarPrecioConvenio(id_pedido){
    (document.querySelector(".formPrecio_"+id_pedido) as HTMLElement).style.display ="flex";
    this.formularioCambiarPrecio.id_pedido = id_pedido;    
  }
  cerrarFormCambiarPrecioConvenio(id_pedido){    
    (document.querySelector(".formPrecio_"+id_pedido) as HTMLElement).style.display ="none";
    this.errorPriceNoNumeric =null;
    this.formularioCambiarPrecio.precio = null;
  }
  cambiarPrecioConvenio(){    
    this.http.post(`${this.url}/cambiarPrecioConvenio`,this.formularioCambiarPrecio).subscribe(
      data =>this.handleResponse(data),
      error =>this.handleError(error)
    )
  }
  
  handleResponse(data){ 
    (document.querySelector(".formPrecio_"+data.id_pedido) as HTMLElement).style.display ="none"; 
    document.querySelector(".precio_convenio_"+data.id_pedido).innerHTML=data.precio; 
    this.errorPriceNoNumeric =null;
    this.formularioCambiarPrecio.precio = null;    
  }

  handleError(error){ 
    this.errorPriceNoNumeric =error.error.errors.precio[0];
  }

  verConstancia(row){    
    this.dialog.open(VerConstanciaComponent,{
      width:"350px",
      data:{datos:row},
      disableClose: false,
      autoFocus:true
    }); 
   
  } 

}

export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  
  
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase{
  constructor(private http: HttpClient,
    private dataApi : DataApiService) {}

  getRepoIssues(typeUserEmpresa:string,typeUser:string,idUser:number,company:string,sort: string, order: string, page: number): Observable<GithubApi> {     
    const href = this.dataApi.url;
    const requestUrl =
        `${href}/mostrarPedidos/${page + 1}/20/${idUser}/${company}/${typeUser}/${typeUserEmpresa}`;

    return this.http.get<GithubApi>(requestUrl);
  } 
}
